import verify from "../../Assets/images/verifytick.svg";
import "./loopview.css";

const LoopFivebody = ({ data }) => {
  return (
    <div className="flex flex-col items-start justify-center text-left h-full gap-3">
      {/* ✅ Image */}
      <img src={verify} alt="Completed" className="w-15 h-15" />

      {/* ✅ Title */}
      <h3
        style={{
          fontFamily: "RecoletaBold",
          fontSize: "30px",
          style: "semibold",
          fontWeight: "600",
        }}
      >
        <span className="block">Loop</span>
        <span className="block">Complete</span>
      </h3>

      {/* ✅ Description */}
      <p className="bodytext1 max-w-[220px]">
        Well done. You’ve completed this Loop and built a real skill.
      </p>
    </div>
  );
};

export default LoopFivebody;
